import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TProfile } from 'api/http-client/profileTypes';

interface State {
  profile: TProfile | null;
}

const initialState: State = {
  profile: null,
};

const userSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    setProfile: (state, action: PayloadAction<TProfile>) => {
      state.profile = action.payload;
    },
  },
});

export const { setProfile } = userSlice.actions;

export default userSlice;
